import React from 'react';
import { useState, useEffect } from 'react';
import { Box, Table, Autocomplete, TextField } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { Confirm, Text } from 'src/mtska-frontend-app-component';

const Previewer = ({ data, model, defaultMapping = {}, onMappingChange, limit = 25 }) => {
    const { t } = useTranslation();
    const [previewLimit, setPreviewLimit] = useState(limit);
    const [mapping, setMapping] = useState(defaultMapping);

    useEffect(() => {
        setMapping(defaultMapping);
    }, [defaultMapping])

    useEffect(() => {
        onMappingChange && onMappingChange(mapping);
    }, [mapping]);

    useEffect(() => {
        if (data && data.length < previewLimit) setPreviewLimit(data.length);
    }, [data]);

    const [hasMappingConflicts, setHasMappingConflicts] = useState(false);

    const applyMapping = (xlscol, newValue) => {

        setHasMappingConflicts(false);

        const newMapping = { ...mapping, [xlscol]: newValue };

        if (newValue === "") {
            delete newMapping[xlscol];
        }

        const previousMapping = Object.keys(mapping).find(key => mapping[key] === newValue);
        if (typeof previousMapping !== "undefined") {
            delete newMapping[previousMapping];
        }

        //console.log('applyMapping newMapping', newMapping);
        setMapping(newMapping);
    }

    const handleMappingChange = (e, newValue, xlscol) => {
        if (!newValue) return;

        const previousMapping = Object.keys(mapping).find(key => mapping[key] === newValue.value);
        //console.log('handleMappingChange newValue', newValue);
        //console.log('handleMappingChange xlscol', xlscol);
        //console.log('handleMappingChange mapping', mapping);
        //console.log('handleMappingChange previousMapping', previousMapping);

        if (typeof previousMapping === "undefined") {
            applyMapping(xlscol, newValue.value);
            return;
        }

        setHasMappingConflicts({ previousMapping: previousMapping, xlscol: xlscol, newValue: newValue.value })
    }

    const getPreviewRows = () => {
        const previewData = data.slice(0, previewLimit);

        return previewData.map((item, rowid) => (
            <tr key={rowid}>
                {
                    Object.keys(item).map((key) => (
                        <td key={key} title={item[key]}>{item[key]}</td>
                    ))
                }
            </tr>
        ));
    }

    return data && (
        <>
            <Text level={"title-md"} className="sectionTitle">{t('Preview of the first {{previewLimit}} rows out of {{totalRows}}', { previewLimit: previewLimit, totalRows: data.length })} </Text>
            <Box className="importer-data-wrapper">
                <Box className="importer-data">
                    <Table>
                        <thead>
                            <tr className="sourceHead">
                                {
                                    Object.keys(data[0]).map((key) => (
                                        <th key={key} title={key}>{key}</th>
                                    ))
                                }
                            </tr>
                            <tr className="mappingHead">
                                {
                                    Object.keys(data[0]).map((key) => (
                                        <th key={key} title={key}>
                                            <span>{t('Map field to')}</span>
                                            <Autocomplete
                                                freeSolo
                                                name={key}
                                                onChange={(e, v) => handleMappingChange(e, v, key)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Cerca"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            className: 'test',
                                                        }}
                                                        onBlur={(e) => {
                                                            handleMappingChange(e, e.target.value, key)
                                                        }}
                                                    />
                                                )}
                                                variant="outlined"
                                                className="form-element-field form-element-field-autocomplete"
                                                
                                                value={mapping[key] ? mapping[key] : (mapping[key.replace('_related_', '')] ? mapping[key.replace('_related_', '')] : '')}
                                                options={
                                                    Array.isArray(model) ? model.map((field, k) => {
                                                        return { key: k, value: field.key, label: t(field.label) + ' (' + field.key + ')' }
                                                    }) : []
                                                }
                                            />
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                getPreviewRows()
                            }
                        </tbody>
                    </Table>
                    {hasMappingConflicts && (
                        <Confirm
                            oklabel={t("Change")}
                            okcallable={() => { applyMapping(hasMappingConflicts.xlscol, hasMappingConflicts.newValue) }}
                            kolabel={t("Cancel")}
                            kocallable={() => { setHasMappingConflicts(false) }}
                            title={t("Attribution conflict")}>
                            {t("The field")} <strong>{hasMappingConflicts.newValue}</strong> {t("is already assigned to column")} <strong>{hasMappingConflicts.previousMapping}</strong>, {t("do you want to assign to column")} <strong>{hasMappingConflicts.xlscol}</strong>?
                        </Confirm>
                    )}
                </Box>
            </Box>
        </>
    );
}


export default Previewer;